<template>
  <div class="foot">
    <div class="container">
      <div class="section">
        <h3>关于公司</h3>
        <ul>
          <li>江城子简介</li>
          <li>发展历程</li>
          <li>领导致辞</li>
        </ul>
      </div>
      <div class="section">
        <h3>产品中心</h3>
      </div>
      <div class="section">
        <h3>工程案例</h3>
      </div>
      <div class="section">
        <h3>技术服务</h3>
      </div>
      <div class="section">
        <h3>企业证书</h3>
      </div>
      <div class="section">
        <h3>联系我们</h3>
      </div>
      <div class="contact-info">
        <h3>联系方式</h3>
        <p>公司总部</p>
        <p>地址：湖北省葛店开发区1号工业园区创业北路</p>
        <p>电话：0711-5110162</p>
      </div>
    </div>
    <div class="code">
      <div class="codebottom">
        <p class="boitem">主办单位：湖北江城子建材科技有限公司</p>
        <p class="boitem">备案号：鄂ICP备2025106953号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.foot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  background-color: #004da0;
  padding-top: 20px;
  padding-bottom: 53px;
  color: #fff;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px; /* 添加间距 */
}

.section {
  text-align: left;
  flex: 1; /* 每个 section 平均分配空间 */
}

.section h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.section ul {
  list-style: none;
  padding: 0;
}

.section ul li {
  font-size: 14px;
  margin: 5px 0;
  cursor: pointer;
}

.section ul li:hover {
  text-decoration: underline;
}

.contact-info {
  text-align: left;
  flex: 1; /* 联系方式部分也平均分配空间 */
}

.contact-info h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.contact-info p {
  font-size: 14px;
  margin: 5px 0;
}

.code {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 20px;
}

.codeimg {
  width: 104px;
  height: 101px;
  background-color: pink;
  margin-bottom: 10px;
}

span {
  margin: 8px 0 20px 0;
  color: #fff;
  font-size: 17px;
}

.codebottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0 30px 0;
  border-top: 0.0002rem solid #1b59b6;
  color: #fff;
}

.boitem {
  margin-top: 4px;
  font-size: 14px;
  text-align: center;
}
</style>
